import PostelRaw from '@/assets/companies/postel/sidebar-logo.svg?react';

export const PostelLogo = ({ width = 170, height=50, className = "" }) => {
  return (
    <PostelRaw
      className={className}
      width={width}
      height={height}
    />
  );
};